import axiosClient from './axios';

const getListJobs = async (filter, current, pageSize, type) => {
  return axiosClient.post(`/get/jobs`, {
    progress: filter,
    page: current,
    recordPerPage: pageSize,
    type: type,
  });
};
const getJobsLength = async () => {
  return axiosClient.post(`/get/jobs/count`, {
    isPrivate: false,
    progress: ['All', 'Active', 'Expired'],
  });
};
const getJobDetail = async (jobId) => {
  return axiosClient.get(`/get/jobs/${jobId}`);
};

const endJobAction = async (jobCode) => {
  try {
    const res = await axiosClient.put(`/job/end/${jobCode}`, {});
    return res
  } catch (error) {
    console.error(error);
  }
};

const reOpenJobAction = async (jobCode) => {
  try {
    const res = await axiosClient.put(`/job/reopen/${jobCode}`, {});
    return res
  } catch (error) {
    console.error(error);
  }
};

const deleteJobAction = async (jobCode) => {
  try {
    const res = await axiosClient.put(`job/delete`, { code: jobCode });
    return res
  } catch (error) {
    console.error(error);
  }
};

// interview
const getInterviews = async (matchCode) => {
  try {
    return axiosClient.get(`/v1/interview/getOne?matchCode=${matchCode}`);
  } catch (error) { }
};
const getOffer = async (matchCode) => {
  try {
    return axiosClient.get(`/v1/offer/getOne?matchCode=${matchCode}`);
  } catch (error) { }
};
const updateInterviews = async (code, workList, meetLink) => {
  return axiosClient.put('/v1/interview/update', {
    isSaveSchedule: false,
    code: code,
    meetingURL: meetLink,
    adminSelectDate: JSON.stringify(workList),
  });
};

export { getListJobs, getJobDetail, endJobAction, reOpenJobAction, deleteJobAction, getJobsLength, getInterviews, updateInterviews, getOffer };
